<google-map #map [options]="getMapOptions()"
  [ngClass]="panelClass"
  (mapClick)="createRouterMark($event)"
  (mapInitialized)="onMapInitialized($event)">
  @if (isManualMapSelected) {
    @for (marker of markers; track $index; let markerIndex = $index) {
      <map-marker
        #mapMarker="mapMarker"
        [options]="getMarkerOptions(marker)"
        (mapClick)="openMapInfo(mapMarker, markerIndex)">
    
        <map-info-window #infoWindow>
          <app-map-marker-info-form
            *ngIf="isMarkerInfoVisible"
            [token]="token"
            [markerInfoToBeEdited]="markers[markerInfoEditIndex]"
            (formSaved)="saveMarkerInfo($event)"
            (markerRemoved)="removeMarker()">
          </app-map-marker-info-form>
        </map-info-window>
    
      </map-marker>
    }
    @if (markers && markers.length > 1) {
      <map-polyline
        [options]="polylineOptions">
      </map-polyline>
    }
  }

  <!-- Directions are rendered via DirectionsRenderer in the component -->
</google-map>
@if (isMarkerCreationInvalid) {
  <div class="custom_error">
    {{translations.MAP.PROVIDE_STARTING_MARKER_LOCATION | translate}}
  </div>
}

